import { all, fork } from "redux-saga/effects";

// Layout (sidebar/topbar mode persistence)
import LayoutSaga from "./layouts/saga";

// Real auth flows
import AuthSaga from "./auth/login/saga";
import ProfileSaga from "./auth/profile/saga";

// (Template demo sagas — calendar/chat/ecommerce/projects/tasks/crypto/tickets/crm/invoice/mailbox/register/forgetpwd —
//  intentionally NOT mounted. Their pages aren't in the route map and parsing
//  them adds startup time. Re-add only when a real feature reaches GA.)

export default function* rootSaga() {
  yield all([
    fork(LayoutSaga),
    fork(AuthSaga),
    fork(ProfileSaga),
  ]);
}
